 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		50: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"273f37c155e03aae1d03379a06636b3b7bd51ede","1":"5e9c9cec3f2b30f65452aa5775cb6c53e0b1a12d","2":"0b7b90cd","8":"component---cache-caches-gatsby-plugin-offline-app-shell-js","9":"component---src-pages-404-js","10":"component---src-pages-admin-app-settings-js","11":"component---src-pages-admin-editor-js","12":"component---src-pages-admin-index-js","13":"component---src-pages-admin-playground-js","14":"component---src-pages-chi-siamo-js","15":"component---src-pages-contatti-js","16":"component---src-pages-corporate-governance-js","17":"component---src-pages-faq-js","18":"component---src-pages-index-js","19":"component---src-pages-lavora-con-noi-js","20":"component---src-pages-login-js","21":"component---src-pages-news-js","22":"component---src-pages-servizi-accessori-additional-insurance-js","23":"component---src-pages-servizi-accessori-cod-js","24":"component---src-pages-servizi-accessori-depot-pickup-js","25":"component---src-pages-servizi-accessori-destination-pay-js","26":"component---src-pages-servizi-accessori-document-return-js","27":"component---src-pages-servizi-accessori-e-com-js","28":"component---src-pages-servizi-accessori-exchange-js","29":"component---src-pages-servizi-accessori-express-12-js","30":"component---src-pages-servizi-accessori-food-service-js","31":"component---src-pages-servizi-accessori-gdo-js","32":"component---src-pages-servizi-accessori-ident-pin-js","33":"component---src-pages-servizi-accessori-info-js","34":"component---src-pages-servizi-accessori-pick-return-js","35":"component---src-pages-servizi-accessori-pick-ship-js","36":"component---src-pages-servizi-accessori-pod-js","37":"component---src-pages-servizi-accessori-return-service-js","38":"component---src-pages-servizi-accessori-saturday-js","39":"component---src-pages-servizi-accessori-sprinters-js","40":"component---src-pages-servizi-express-js","41":"component---src-pages-servizi-js","42":"component---src-pages-servizi-logistics-js","43":"component---src-pages-servizi-national-express-js","44":"component---src-pages-servizi-parcel-js","45":"component---src-pages-servizi-safe-plus-js","46":"component---src-pages-servizi-servizi-accessori-js"}[chunkId]||chunkId) + "-" + {"0":"07f8a01833768eb70800","1":"fdab1c0e14e2fb3ba0b1","2":"8cac74806d46e3f2814d","8":"475d7c6d00c2247f0780","9":"b110d5548a4f610a82a9","10":"0c8962691b848d381b59","11":"39e94210869cbc73cfa7","12":"ad66fe5778ab9a3cc41d","13":"f1bf0857017f46e89cd9","14":"14734888976cf169fbf4","15":"62225bd1fe97e898c8dc","16":"38c303e072e3bbaf89cf","17":"df51a630f97e8b9b26e7","18":"906fe6925101d8d6c3fb","19":"3836bc782722886500af","20":"7c992aa79c9c010a2f1f","21":"95f0d4e0f4588ddc0722","22":"a131c815cd869f37e83a","23":"85fe7b5501524203b010","24":"aae1bccdf399b7cba4a6","25":"38ff8363c9a0cb2eaafb","26":"0bdd78eff00a197704f9","27":"c8c403d6303251329d93","28":"28246f38c317e45bf4d0","29":"1bd9d7a46e69c5c770bd","30":"b5b391e236862e547955","31":"baa6093db83aecd3012a","32":"23e23e183a71cf3f4dc9","33":"a96b0b0b54607e61cc41","34":"cbc466a017225fc2ee44","35":"901a1a9bee0996d59491","36":"b9ba6affe4f49b96e003","37":"917075e972e3475d7b34","38":"e91ffe3d0fb9c92fa752","39":"d5b03f853b6379abad70","40":"5c6ade7a823acc86491f","41":"4bf9b88adf67f0651381","42":"a748b811eff5bc790d4b","43":"42c9ac532b2812138900","44":"2fbcfebc518342bef9c2","45":"ae267fabdf20cf2baff1","46":"de301fa64ca3f04ff15b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
